import React from 'react'
import { CURRENT_LOCATION_ICON } from 'image/icon'
import { locationStore } from 'store/location'
import { MapStore } from 'store/map'
import { observer } from 'mobx-react'
import { BottomButton } from './bottom-button-common'
import { BOTTOM_VIEW_HORIZONTAL_DISTANCE } from 'infra/constant'

export const CurrentLocationButton: React.FC<{
  mapStore: MapStore
}> = observer(({ mapStore }) => {
  if (mapStore.selectedPlace) return null
  return (
    <BottomButton
      onPress={() => {
        locationStore
          .getLocation(true)
          .then((x) => mapStore.focusLocation(x))
          .catch((error) => console.warn('[CurrentLocation]', error))
      }}
      imageSource={CURRENT_LOCATION_ICON}
      style={{ right: BOTTOM_VIEW_HORIZONTAL_DISTANCE }}
    />
  )
})
